const initContactMap = () => {
    const mapCenter = { lat: 50.14446914091611, lng: 14.578730040789148 }
    map = new google.maps.Map(document.querySelector(".js-contact-map"), {
      center: mapCenter,
      zoom: 19,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      gestureHandling: "cooperative",
      styles: [{
        featureType: "poi",
        elementType: "labels",
        stylers: [{
          visibility: "off"
        }]
      }]
    });

    const marker = new google.maps.Marker({
        position: mapCenter,
        icon: themeUrl+"/img/kontakt_placeholder.svg",
        map: map,
    });
}